import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { MEDIA_QUERIES } from './media_query';
import classNames from 'classnames';

const isLeftArrow = ({ key, keyCode }) =>
  key === 'ArrowLeft' || keyCode === 37;

const isRightArrow = ({ key, keyCode }) =>
  key === 'ArrowRight' || keyCode === 39;

export default class TrinityAudioPlayer extends PureComponent {
  constructor(props) {
    super(props);
    this.wrapperRef = React.createRef();
    this.state = {
      slideCount: 0,
      isPlayerReady: false,
      notDesktop: false,
    };
  }

  componentDidMount() {
    this.positionPlayer(); 
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize);

    this.loadDelay = setTimeout(() => {
      this.loadPlayer();
    }, 800)

    document.addEventListener('click', this.handleClick);
    document.addEventListener('keydown', this.handleKeyDown, { passive: false });
  }

  componentDidUpdate(prevState) {
    if (prevState.slideCount !== this.state.slideCount) {
      this.removePlayer();
      this.reloadPlayer();
    }
  }

  componentWillUnmount() {
    clearTimeout(this.loadDelay);
    this.removePlayer();
    document.removeEventListener('click', this.handleClick);
    document.removeEventListener('keydown', this.handleKeyDown);
    window.removeEventListener('resize', this.checkScreenSize);
  }

  positionPlayer = () => {
    const contentElement = document.querySelector('#article-main-content');
    if (contentElement && this.wrapperRef.current) {
      contentElement.insertBefore(this.wrapperRef.current, contentElement.firstChild);
    }
  }

  checkScreenSize = () => {
    const notDesktop = window.innerWidth < MEDIA_QUERIES.desktop.minWidth;
    if (this.state.notDesktop !== notDesktop) {
      this.setState({ notDesktop });
    }
  }

  handleClick = (event) => {
    const clickedElement = event.target;
    const nextButton = clickedElement.closest('.nav-right');
    const prevButton = clickedElement.closest('.nav-left');

    if (nextButton || prevButton) {
      this.setState(prevState => ({
        slideCount: prevState.slideCount + 1
      }));
    }
  }

  handleKeyDown = (event) => {
    if (isLeftArrow(event) || isRightArrow(event)) {
      this.setState(prevState => ({ 
        slideCount: prevState.slideCount + 1
      }));
    }
  }

  loadPlayer = () => {
    if (this.state.isPlayerReady) return;

    try {
      const scriptEl = document.createElement('script');
      scriptEl.setAttribute('fetchpriority', 'high');
      scriptEl.setAttribute('charset', 'UTF-8');

      // a specific player was created by trinity to skip the title for slideshow articles
      const userId = this.props.isSlideshowArticle ? 2900021325 : 2900020793;

      const scriptUrl = new URL(`https://trinitymedia.ai/player/trinity/${userId}/?`);
      scriptUrl.searchParams.set('pageURL', encodeURIComponent(window.location.href));

      if (this.props.isSlideshowArticle && this.state.notDesktop) {
        const slideshowMobileText = encodeURIComponent(btoa('section-text'));
        scriptUrl.searchParams.set('textSelector', slideshowMobileText);
      } 

      scriptEl.src = scriptUrl.toString();

      scriptEl.onload = () => {
        this.setState({ isPlayerReady: true });
        window.TRINITY_PLAYER.api.createPlayer();
      }

      document.body.appendChild(scriptEl);
    } catch (err) {
      console.error('Error setting up Trinity Audio player:', err);
    }
  }

  reloadPlayer = () => {
    if (!this.state.isPlayerReady) return;

    setTimeout(() => {
      try {
        window.TRINITY_PLAYER.api.createPlayer();     
      } catch (err) {
        console.error('Error reloading Trinity Audio player:', err);
      }
    }, 50)

  }

  removePlayer = () => {
    try {
      window.TRINITY_PLAYER.api.removePlayer();
    } catch (err) {
      console.error('Error removing Trinity Audio player:', err);
    }
  }

  render() {
    const { title } = this.props;
    return (
    <div className={classNames(this.props.className, "trinityAudioPlaceholder")} ref={this.wrapperRef}>
      <div className="trinity-tts-pb" dir="ltr">
      </div>
    </div>
    );
  }
}

TrinityAudioPlayer.propTypes = {
  isSlideshowArticle: PropTypes.bool
};